import axios from 'axios'
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext'
import Loading from '../helper/Loading';
import PageHeader from '../helper/PageHeader';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import DeleteDialog from '../helper/Dialogs';
import withStyles from '@mui/styles/withStyles';
import styles from "../styles";
import React, { useEffect, useState, useContext,  Fragment } from 'react'
import SortedTable from '../helper/SortedTable';
import moment from 'moment';
import { withTranslation } from 'react-i18next';


const classCredit = 15;
const EmployerTraining = props => {

    const history = useHistory();
    const params = useParams();
    const context = useContext(authContext)
    const { t } = props;
    const token = sessionStorage.getItem('accessToken');

    const { classes } = props;

    const [loading, setLoading] = useState(true)


    const [infoContacts, setInfoContacts ] = useState({
            email: '',
            users: [],
            info: null,
            error: null,
            selectedUser: undefined,
            contacts: [],
           // isDeleteDialogOpen: false,
           // itemToDelete: '',
            isDeleteTraineeDialogOpen: false,
            credit: 0,
            firstName: '',
            lastName: '',
            middleName: '',
            dob: null,
            supervisorLastName: '',
            traineeToDelete: '',
            trainees: []
        
    });

    const [groupData, setGroupData] = useState({
            groupName: '',
            groupType: 'Employer',
            groupContact: undefined,
            groupID: params.id,
    });
    
    useEffect(()=>{
        setLoading(false);
        async function getGroupInformation(){
            setLoading(true)
            try {
                let res = await axios.get('/api/userGroup/' + params.id, {});
                let group = res.data;

                setGroupData(prevState =>{
                  return {...prevState,
                      groupName: group.usergroup.name,
                  }
                });
                let url = '/api/employerTraining/' + params.id ;
                res  = await axios.get(url, {});
                let result = res.data;

                setInfoContacts(prevState =>{
                    return {...prevState, 
                        credit: group.usergroup.credit,
                        trainees: result.trainees,
                        loading: false
                    }
                });

                setLoading(false)
            } catch (error) {
                setInfoContacts(prevState =>{
                return {...prevState, error: error.message }
                });
            }
        }
        if ( params.id !== undefined) 
            getGroupInformation();
        else 
            console.log("In else");
            
    }, [infoContacts.error, params.id]);

    // Move to below header or somewhere else
    //if (info.contacts.length === 0) return <NoDataFound message="No contacts found" />;

    const openDeleteTraineeDialog = (tag) => {
       // this.setState({ traineeToDelete: tag });
        setInfoContacts(prevState =>{
            return {...prevState, traineeToDelete: tag }
        });
        handleDeleteTraineeDialogOpen();
    }

    const handleDeleteTraineeDialogOpen = () => {
        setInfoContacts(prevState =>{
            return {...prevState, isDeleteTraineeDialogOpen: true }
        });
    };

    const handleDeleteTraineeDialogClose = () => {

        setInfoContacts(prevState =>{
            return {...prevState, isDeleteTraineeDialogOpen: false }
        });

    };

    const handleChange = event => {
        setInfoContacts(prevState =>{
            return {...prevState, [event.target.name]: event.target.value }
        });
    }

    const hideInfo = () => {

        setInfoContacts(prevState =>{
            return {...prevState, info: '' }
        });
    }

    const onPurchaseCredit = (event) => {
        props.history.push('/dashboard/employer/' + params.id + '/addCredit',{
            credit:  infoContacts.credit 
        })
    }

    const onBack = (event) => {
        if (props.admin) {
            props.history.push('/administration/employers/', {
                });
        } else {
            props.history.push('/dashboard/employers/' + context.user.username ,{
                });
        }
    }

    let enhancedData = [];
    enhancedData = infoContacts.trainees.map((arrayItem) => {
        let item = JSON.parse(JSON.stringify(arrayItem));
        console.log(item)
        item.employeeName = item.employeeMiddleName ? item.employeeLastName + ", " + item.employeeFirstName + ' ' + item.employeeMiddleName
            : item.employeeLastName + ", " + item.employeeFirstName;
        item.assignBy = item.last_name? item.last_name  + ', ' + item.first_name : '';
        item.enableLink = item.trainingId ? true : false;
        item.statusView =  t('trainingStatus.Status', { context: item.status });
        item.actionsDisabled = {
            delete: item.status !== "Assigned",
            showResult: item.employeeUserID !== null  && item.trainingId !== null,
            allowRequestCertificate : item.status === "Passed" && item.disabled !== true
        }
        return item;
    });
    console.log(enhancedData);
    const onTrainingInfo = (id) => {
        let currentRow = infoContacts.trainees.find(e => e.id === id);
        axios.get('/api/userTraining/' + currentRow.trainingId).then((res) => {
            let userTraining = res.data.training;
   
            props.history.push('/dashboard/trainingHistory/details', { 
                trainingId: currentRow.trainingId, 
                username: currentRow.employeeUserID, 
                courseID: userTraining.courseId, 
                courseLabel: userTraining.courseLabel,
                courseType: userTraining.type,
                restricted: true // employer has restricted view on trainee's training detail
            });
        }).catch(error => {
           // this.setState({ error: error.message });
            setInfoContacts(prevState =>{
                return {...prevState, error: error.message }
            });
        });
    }

    const headCells = [
        { id: 'Action', label: 'Action', centered: false},
        { id: 'lastModified', label: 'Assign Date', centered: false, sortable: true },
        { id: 'assignBy', label: 'Assign By', centered: false, sortable: true },
        { id: 'employeeName', label: 'Employee Name', centered: false,sortable: true},
        { id: 'employeeDOB', label: 'Employee DOB', centered: false,sortable: true },
        { id: 'supervisorLastName', label: 'Supervisor Last Name', centered: false ,sortable: true},
        { id: 'employeeUserID', label: 'Employee Username', centered: false,sortable: true },
        { id: 'statusView', label: 'Status', centered: true, sortable: true },
        { id: 'certID', label: 'Certificate ID', centered: true, sortable: true}
    ];

    const bodyCells = [
        { id: 'lastModified', centered: false},
        { id: 'assignBy', centered: false},
        { id: 'employeeName', centered: false },
        { id: 'employeeDOB',  centered: false },
        { id: 'supervisorLastName', centered: false },
        { id: 'employeeUserID', centered: false, hyperlink: onTrainingInfo },
        { id: 'statusView', centered: true },
        { id: 'certID', centered: true }
    ];

    const onRequestCertificate = (id) => {

        let currentRow = enhancedData.find(e => e.id === id);
        console.log('id clicked', currentRow.employeeUserID )
    
       history.push({
           pathname : '/dashboard/userCertificateRequest/' + currentRow.employeeUserID,
           state: { 
            employerName : groupData.groupName,
            certID: currentRow.certID,
            certDate:  moment(currentRow.certDate).format('YYYY-MM-DD hh:mm:ss A')
         }
         })    

    }


    const actionButtons = [
        { icon: "delete", action: openDeleteTraineeDialog, delete: true },
        { icon: "training", label: "Employee Result", action: onTrainingInfo, view: "showResult"},
        {icon : 'requestcertificate',label: 'Certificate', action: onRequestCertificate, view: "allowRequestCertificate"  }
    ];

    const defaultSortKey = 'lastModified';
    const editDelete = false;
    
    const onAssignCredit = async (event) => {
        event.preventDefault();

        console.log("onAssignCredit: " + infoContacts.credit);
        console.log("classCredit: " + classCredit);
        let newCredit = infoContacts.credit - classCredit;

        console.log("newCredit: " + newCredit);
        let data = {
            UserGroupID: groupData.groupID,
            EmployeeFirstName: infoContacts.firstName,
            EmployeeLastName: infoContacts.lastName,
            EmployeeMiddleName: infoContacts.middleName,
            EmployeeDOB: infoContacts.dob,
            SupervisorLastName: infoContacts.supervisorLastName,
            ClassCredit: classCredit,
            EmployeeUserID: null,
            LastModifiedBy: context.user.username,
            NewCredit: newCredit,
        }
        try {
            let res = await axios('/api/employerTraining/', {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (res) {
                let url = '/api/employerTraining/' + groupData.groupID;
                let result = await axios(url, {
                    method: 'GET'
                });
                console.log(result); 
                setInfoContacts(prevState =>{
                    return {...prevState, 
                        trainees: result.data.trainees,
                        credit: newCredit
                } });
            }
          
        } catch (err) {
            // handled by App.js
        }  
    }

    const onRemoveTrainee = (event) => {
        // get the trainee record id
         handleDeleteTraineeDialogClose();
         console.log('in remove trainee');
         let traineeID = infoContacts.traineeToDelete;
         console.log('trainee id', traineeID);
     //    console.log(groupID);
         console.log('username', context.user.username );

         setInfoContacts(prevState =>{
            return {...prevState, traineeToDelete: ''}
        });

         let newCredit = infoContacts.credit + classCredit;
 
         var data = {
             employerID: groupData.groupID,
             credit: newCredit,
             byUsername: context.user.username
         }
         let url = '/api/employerTraining/' + traineeID;
         axios(url, {
             method: 'DELETE',
             data: JSON.stringify(data),
             headers: {
                 'Content-Type': 'application/json',
                 'Authorization': token
             }
         }).then(response => {
             if (response.status >= 400) {
                 throw new Error(response.statusText);
             }
             let url = '/api/employerTraining/' + groupData.groupID;
             axios(url, {
                 method: 'GET'
             }).then(res => res.data)
                 .then(result => {
                     console.log(result);

                     setInfoContacts(prevState =>{
                        return {...prevState, trainees: result.trainees,
                            credit: newCredit }
                    });



                 }).catch(error => {

                    //  this.setState({ 
                    //      error: error.message 
                    //  });

                     setInfoContacts(prevState =>{
                        return {...prevState,  error: error.message }
                    });

                 });
         }).catch(err => {
             console.log(err);
            //  this.setState({                         
            //      error: err.message 
            //  });
             setInfoContacts(prevState =>{
                return {...prevState,  error: err.message }
            });
         });
     }

    return (
        <>
        {
            loading 
            ? 
            <Loading />
            : 
            <Fragment>
                <PageHeader
                    title={"Manage Employee Online Training for " + groupData.groupName}
                    cancel={onBack}
                    actionButtons={[{ label: "Add Credit to Purchase Training/Test", action: onPurchaseCredit }]}
                />
                <Alert severity="info">You have ${ infoContacts.credit } credit. Each employee online training/test costs $15.</Alert>
                
                {
                infoContacts.credit === 0 &&
                    <Alert severity="warning">Please purchase credit before adding trainee.</Alert>

                }

                <ValidatorForm
                    noValidate
                    onSubmit={onAssignCredit}
                >

                    {
                    infoContacts.info &&
                        <div>
                            <Alert severity="error" onClose={hideInfo}>{ infoContacts.info }</Alert>
                            <br />
                        </div>
                    }
                    <br/>
                    <p>Assign $15 online training/test credit to this employee:</p>
                    <Grid container spacing={3}>

                        <Grid item md={4} xs={12}>

                            <TextValidator
                                label="Employee First Name"
                                type="text"
                                name='firstName'
                                value={ infoContacts.firstName}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                validators={['required']}
                                errorMessages={['First Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item md={4}  xs={12}>
                            <TextValidator
                                label="Employee Last Name"
                                type="text"
                                name='lastName'
                                value={ infoContacts.lastName }
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                validators={['required']}
                                errorMessages={['Last Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <TextValidator
                                label="Employee Middle Name (optional)"
                                type="text"
                                name='middleName'
                                value={ infoContacts.middleName }
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                fullWidth
                            />
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <TextValidator
                                label="Supervisor Last Name"
                                type="text"
                                name='supervisorLastName'
                                value={ infoContacts.supervisorLastName}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                validators={['required']}
                                errorMessages={['Supervisor Last Name is required', 'Please enter a valid name']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <TextValidator
                                id="date"
                                label="Employee Date of Birth (optional)"
                                type="date"
                                name='dob'
                                value={ infoContacts.dob || ""}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth

                            />
                        </Grid>

                        <Grid item md={4} xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button variant="contained" color="primary" className={[].join(' ')} disabled = {infoContacts.credit < classCredit} type="submit" >Assign Credit</Button>
                        </Grid>
                    </Grid>

                    <br /><br />
                    <SortedTable
                                data={enhancedData}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={defaultSortKey}
                                defaultOrder={"desc"}
                                cellKey={"id"}
                                editDelete={editDelete}
                                actionButtons={actionButtons}
                                actions={true}
                            />  

                    <DeleteDialog
                        open={ infoContacts.isDeleteTraineeDialogOpen}
                        onClose={handleDeleteTraineeDialogClose}
                        onDelete={onRemoveTrainee}
                    />
                </ValidatorForm>
            </Fragment>
        }
        </>

    )
}

export default withStyles(styles, { withTheme: true })(withTranslation()(EmployerTraining));
